module.exports = __webpack_public_path__ + "static/heart-animation-7d47e2b26e26d1f5280c24f4824fa9e2.png";